import { Component, Inject, OnInit, ViewEncapsulation } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
    selector: "app-dialog-pago-contratista",
    templateUrl: "./dialog-pago-contratista.component.html",
    styleUrls: ["./dialog-pago-contratista.component.scss"],
    encapsulation: ViewEncapsulation.None,
})
export class DialogPagoContratistaComponent implements OnInit {
    formPago: FormGroup;
    constructor(
        public dialogRef: MatDialogRef<DialogPagoContratistaComponent>,
        private _fb: FormBuilder
    ) {}

    ngOnInit(): void {
        this.initForm();
    }

    initForm() {
        this.formPago = this._fb.group({
            monto: [
                "",
                {
                    validators: [Validators.required, Validators.min(1)],
                },
            ],
        });
    }

    get monto() {
        return this.formPago.get("monto");
    }
}
